module.exports = __webpack_public_path__ + "img/mic.ac5cc29f.svg";